import {Injector} from '@angular/core';

import {LOCATION_INITIALIZED} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

export function ApplicationTranslateInitializerFactory(
    translate: TranslateService, injector: Injector): any {
    return async () => {
        await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

        translate.addLangs(['de', 'en', 'sr']);
        translate.setDefaultLang('de');
        const browserLang = translate.getBrowserLang();
        const browserLangMatch = browserLang.match(/en|de|sr/);
        const localStorageLang = localStorage.getItem('languageCode');
        if (localStorageLang) {
            translate.use(localStorageLang);
            localStorage.setItem('languageCode', localStorageLang);
        } else {
            translate.use(browserLangMatch ? browserLang : 'de');
            browserLangMatch ? localStorage.setItem('languageCode', browserLang) : localStorage.setItem('languageCode', 'de');
        }
    };
}
